/**
 * Copyright (c) Microblink Ltd. All rights reserved.
 */

/**
 * Represents the different levels of detection sensitivity.
 *
 * This enum class is used to configure detection thresholds and enable or
 * disable detection functionality. The levels range from turning detection
 * off completely to setting various levels of sensitivity (Low, Mid, High).
 */
export enum DetectionLevel {
    Off,
    Low,
    Mid,
    High
}
